// ** React Imports
import { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout';

// ** Menu Items Array
import navigation from '@src/navigation/vertical';
import { useSelector } from 'react-redux';

const VerticalLayout = (props) => {
  const [menuData, setMenuData] = useState([]);
  const { userData } = useSelector((state) => state.auth);

  const handleAllowed = useCallback(() => {
    const newData = navigation.filter((item) =>
      userData?.permissions?.includes(item.id)
    );
    setMenuData(newData);
  }, [userData]);

  // ** For ServerSide navigation
  useEffect(() => {
    handleAllowed();
  }, [handleAllowed]);

  return (
    <Layout menuData={menuData} {...props}>
      <Outlet />
    </Layout>
  );
};

export default VerticalLayout;
